import type { AppConfiguration, AppSelector } from "src/types";
import { configApi } from "./serverApi";

const getConfigQueryState = configApi.endpoints.AppConfig.select();

export const getAppConfig: AppSelector<AppConfiguration | undefined> = (state) => getConfigQueryState(state).data;
